module.exports = __webpack_public_path__ + "static/media/redDart.3c91b95e.svg";